import { render, staticRenderFns } from "./CoronarografiaPtcaEditComponent.vue?vue&type=template&id=6dc0b0f8&scoped=true"
import script from "./CoronarografiaPtcaEditComponent.vue?vue&type=script&lang=js"
export * from "./CoronarografiaPtcaEditComponent.vue?vue&type=script&lang=js"
import style0 from "./CoronarografiaPtcaEditComponent.vue?vue&type=style&index=0&id=6dc0b0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc0b0f8",
  null
  
)

export default component.exports